export const TrackingNamespace = {
  namespace: {
    app: 'ondemand',
    page: 'interactive_transcript',
  },
};
